import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=e880a2f4"
import script from "./ProjectStatus.vue?vue&type=script&lang=ts"
export * from "./ProjectStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e880a2f4')) {
      api.createRecord('e880a2f4', component.options)
    } else {
      api.reload('e880a2f4', component.options)
    }
    module.hot.accept("./ProjectStatus.vue?vue&type=template&id=e880a2f4", function () {
      api.rerender('e880a2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectStatus.vue"
export default component.exports